import { OptionalStateCarts, StateCart, StateCartEntry } from '../CartsState';
import { CustomOrderType } from '../CustomOrderType';
import { RootState } from '../../RootState';
import { createSelector } from '@reduxjs/toolkit';
import selectCarts from './selectCarts';

export type SelectProductQuantityInCartsSelector = (
  state: RootState
) => ReadonlyArray<ProductQuantityPerCart>;

export type ProductQuantityPerCart = {
  readonly cartType: CustomOrderType;
  readonly quantity: number;
};

export type OptionalCartQuantities = Record<CustomOrderType, number>;

const createSelectProductQuantityInCarts = (
  productCode: string
): SelectProductQuantityInCartsSelector => {
  return createSelector([selectCarts], (carts: OptionalStateCarts) => {
    const productQuantityInCarts: Array<ProductQuantityPerCart> = [];
    Object.entries(carts).forEach(([key, cart]: [string, StateCart | null]) => {
      if (cart) {
        const productQuantityInCart: number | undefined = cart.entries.find(
          (entry: StateCartEntry): boolean => productCode === entry.product.code
        )?.quantity;
        if (productQuantityInCart !== undefined) {
          productQuantityInCarts.push({
            cartType: key as keyof OptionalCartQuantities,
            quantity: productQuantityInCart
          });
        }
      }
    });
    return productQuantityInCarts;
  });
};

export default createSelectProductQuantityInCarts;
